import React, { ComponentPropsWithRef, forwardRef } from 'react';
import cn from 'classnames';

import css from 'styles/components/common/card.scss';

type CardProps = ComponentPropsWithRef<'article'> & { allowSwatchGrouping?: boolean };
// eslint-disable-next-line prefer-arrow-callback
export const Card = forwardRef<HTMLElement, CardProps>(function Card(props, ref) {
  const { children, className, allowSwatchGrouping, ...rest } = props;

  return (
    <article ref={ref} className={cn(css.card, className, { [css.isSwatchGrouping]: allowSwatchGrouping })} {...rest}>
      {children}
    </article>
  );
});

export default Card;
